import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import PaymentState, {PaymentList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<PaymentState> = {
  [mutationType.GET_LISTS](
    state: PaymentState,
    data: PaymentList,
  ): void {
    state.list = data
  },
}

export default mutations
